<template>
  <div class="app-shell">

    <!-- Overlay mobile -->
    <div class="sidebar-overlay" :class="{ active: sidebarVisible }" @click="toggleSidebar"></div>

    <!-- ── Sidebar ── -->
    <aside class="app-sidebar" :class="{ open: sidebarVisible, collapsed: sidebarCollapsed }">

      <!-- Brand -->
      <div class="sidebar-brand">
        <a href="/" class="sidebar-brand-link">
          <span class="sidebar-brand-name">ANW</span>
          <span class="sidebar-brand-tag">logistics</span>
        </a>
        <button class="sidebar-close-btn" @click="toggleSidebar" v-show="sidebarVisible">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <!-- Nav -->
      <nav class="sidebar-nav" ref="sidebarNav">

        <!-- Dashboard -->
        <a href="/dashboard" class="nav-item" :class="{ active: isActive(['/dashboard']) }">
          <i class="bi bi-speedometer2 nav-icon"></i>
          <span>Dashboard</span>
        </a>

        <!-- ── LOCAL ── -->
        <div class="nav-section-label">Local</div>

        <!-- Local · Mercadería -->
        <div class="nav-group" :class="{ open: menuOpen['local-mercaderia'] }">
          <button class="nav-group-toggle" @click="toggleMenu('local-mercaderia')">
            <i class="bi bi-box-seam nav-icon"></i>
            <span>Mercadería</span>
            <i class="bi bi-chevron-right nav-chevron"></i>
          </button>
          <div class="nav-sub">
            <a href="/programacion" class="nav-sub-item"
              :class="{ active: isActive(['/programacion']) }">Normal</a>
            <a href="/envios-locales-emergencias" class="nav-sub-item"
              :class="{ active: isActive(['/listado-envios-locales-emergencias', '/envios-locales-emergencias', '/editar-envio/locales-emergencias']) }">Urgencia / Emergencia</a>
            <a href="/listado-envios-locales" class="nav-sub-item"
              :class="{ active: isActive(['/listado-envios-locales']) }">Listado de Envíos</a>
          </div>
        </div>

        <!-- Local · Documentos -->
        <div class="nav-group" :class="{ open: menuOpen['local-documentos'] }">
          <button class="nav-group-toggle" @click="toggleMenu('local-documentos')">
            <i class="bi bi-file-earmark-text nav-icon"></i>
            <span>Documentos</span>
            <i class="bi bi-chevron-right nav-chevron"></i>
          </button>
          <div class="nav-sub">
            <a href="/programacion-documentos" class="nav-sub-item"
              :class="{ active: isActive(['/programacion-documentos']) }">Normal</a>
            <a href="/envios-locales-documentos-emergencias" class="nav-sub-item"
              :class="{ active: isActive(['/listado-envios-locales-documentos-emergencias', '/envios-locales-documentos-emergencias', '/editar-envio/locales-documentos-emergencias']) }">Urgencia / Emergencia</a>
            <a href="/listado-envios-documentos-locales" class="nav-sub-item"
              :class="{ active: isActive(['/listado-envios-documentos-locales']) }">Listado de Envíos</a>
          </div>
        </div>

        <!-- Documentos de Transporte -->
        <a v-show="esAdmin() || esExterno()" href="/documentos-transporte" class="nav-item"
          :class="{ active: isActive(['/documentos-transporte']) }">
          <i class="bi bi-truck nav-icon"></i>
          <span>Documentos de Transporte</span>
        </a>

        <!-- ── PROVINCIA ── -->
        <div v-show="esAdmin() || esExterno()" class="nav-section-label">Provincia</div>

        <!-- Provincia · Mercadería -->
        <div v-show="esAdmin() || esExterno()" class="nav-group" :class="{ open: menuOpen['provincia-mercaderia'] }">
          <button class="nav-group-toggle" @click="toggleMenu('provincia-mercaderia')">
            <i class="bi bi-boxes nav-icon"></i>
            <span>Mercadería</span>
            <i class="bi bi-chevron-right nav-chevron"></i>
          </button>
          <div class="nav-sub">
            <a href="/envios/consolidado" class="nav-sub-item"
              :class="{ active: isActive(['/listado-envios/consolidados', '/envios/consolidado', '/editar-envio/consolidado']) }">Consolidado Terrestre</a>
            <a href="/envios/exclusivo" class="nav-sub-item"
              :class="{ active: isActive(['/listado-envios/exclusivos', '/envios/exclusivo', '/editar-envio/exclusivo']) }">Exclusivo Terrestre</a>
            <a href="/envios/aereo" class="nav-sub-item"
              :class="{ active: isActive(['/listado-envios/aereos', '/envios/aereo', '/editar-envio/aereo']) }">Consolidado Aéreo</a>
            <a href="/listado-envios/mercaderia" class="nav-sub-item"
              :class="{ active: isActive(['/listado-envios/mercaderia']) }">Listado de Envíos</a>
          </div>
        </div>

        <!-- Provincia · Documentos -->
        <div v-show="esAdmin() || esExterno()" class="nav-group" :class="{ open: menuOpen['provincia-documentos'] }">
          <button class="nav-group-toggle" @click="toggleMenu('provincia-documentos')">
            <i class="bi bi-files nav-icon"></i>
            <span>Documentos</span>
            <i class="bi bi-chevron-right nav-chevron"></i>
          </button>
          <div class="nav-sub">
            <a href="/envios-documentos/consolidado" class="nav-sub-item"
              :class="{ active: isActive(['/listado-envios-documentos/consolidados', '/envios-documentos/consolidado', '/editar-envio-documento/consolidado']) }">Consolidado Terrestre</a>
            <a href="/envios-documentos/exclusivo" class="nav-sub-item"
              :class="{ active: isActive(['/listado-envios-documentos/exclusivos', '/envios-documentos/exclusivo', '/editar-envio-documento/exclusivo']) }">Exclusivo Terrestre</a>
            <a href="/envios-documentos/aereo-documentos" class="nav-sub-item"
              :class="{ active: isActive(['/listado-envios-documentos/aereos', '/envios-documentos/aereo-documentos', '/editar-envio-documento/aereo']) }">Consolidado Aéreo</a>
            <a href="/listado-envios/documentos" class="nav-sub-item"
              :class="{ active: isActive(['/listado-envios/documentos']) }">Listado de Envíos</a>
          </div>
        </div>

        <!-- Datos de Agente -->
        <a v-show="esAdmin() || esExterno()" href="/datos-agente" class="nav-item"
          :class="{ active: isActive(['/datos-agente']) }">
          <i class="bi bi-person-badge nav-icon"></i>
          <span>Datos de Agente</span>
        </a>

        <!-- ── OTROS ── -->
        <div class="nav-section-label">Otros</div>

        <a v-show="esAdmin() || esExterno()" href="/cotizador" class="nav-item"
          :class="{ active: isActive(['/cotizador']) }">
          <i class="bi bi-calculator nav-icon"></i>
          <span>Calculadora</span>
        </a>

        <a href="/tracking" class="nav-item" :class="{ active: isActive(['/tracking']) }">
          <i class="bi bi-geo-alt nav-icon"></i>
          <span>Rastreo Provincia</span>
        </a>

        <a href="/tracking-local" class="nav-item" :class="{ active: isActive(['/tracking-local']) }">
          <i class="bi bi-pin-map nav-icon"></i>
          <span>Rastreo Local</span>
        </a>

        <!-- ── ADMINISTRACIÓN ── -->
        <div v-show="esAdmin()" class="nav-section-label">Administración</div>

        <!-- Gestión de Costos -->
        <div v-show="esSuperAdminAdmin()" class="nav-group" :class="{ open: menuOpen['gestion-costos'] }">
          <button class="nav-group-toggle" @click="toggleMenu('gestion-costos')">
            <i class="bi bi-currency-dollar nav-icon"></i>
            <span>Gestión de Costos</span>
            <i class="bi bi-chevron-right nav-chevron"></i>
          </button>
          <div class="nav-sub">
            <a href="/gestion-costo-aereo" class="nav-sub-item"
              :class="{ active: isActive(['/gestion-costo-aereo']) }">Costos Aéreos</a>
            <a href="/gestion-costo-terrestre" class="nav-sub-item"
              :class="{ active: isActive(['/gestion-costo-terrestre']) }">Costos Terrestres</a>
            <a href="/gestion-costo-terrestre-exclusivo" class="nav-sub-item"
              :class="{ active: isActive(['/gestion-costo-terrestre-exclusivo']) }">Costos Exclusivos</a>
          </div>
        </div>

        <!-- Gestión de Flota -->
        <div v-show="esSuperAdminAdmin()" class="nav-group" :class="{ open: menuOpen['gestion-flota'] }">
          <button class="nav-group-toggle" @click="toggleMenu('gestion-flota')">
            <i class="bi bi-truck-flatbed nav-icon"></i>
            <span>Gestión de Flota</span>
            <i class="bi bi-chevron-right nav-chevron"></i>
          </button>
          <div class="nav-sub">
            <a href="/gestion-tipos-unidades" class="nav-sub-item"
              :class="{ active: isActive(['/gestion-tipos-unidades']) }">Tipos de Unidades</a>
            <a href="/gestion-vehiculos" class="nav-sub-item"
              :class="{ active: isActive(['/gestion-vehiculos']) }">Vehículos</a>
          </div>
        </div>

        <a v-show="esSuperAdminAdmin()" href="/gestion-metodo-envio" class="nav-item"
          :class="{ active: isActive(['/gestion-metodo-envio']) }">
          <i class="bi bi-send nav-icon"></i>
          <span>Métodos de Envío</span>
        </a>

        <a v-show="esSuperAdminAdmin()" href="/datos-personal" class="nav-item"
          :class="{ active: isActive(['/datos-personal']) }">
          <i class="bi bi-people nav-icon"></i>
          <span>Gestión de Personal</span>
        </a>

        <a v-show="esAdmin()" href="/gestion-usuarios" class="nav-item"
          :class="{ active: isActive(['/gestion-usuarios']) }">
          <i class="bi bi-person-check nav-icon"></i>
          <span>Gestión de Usuarios</span>
        </a>

        <a v-show="esAdmin()" href="/company" class="nav-item" :class="{ active: isActive(['/company']) }">
          <i class="bi bi-briefcase nav-icon"></i>
          <span>Gestión de Clientes</span>
        </a>

        <a v-show="esSuperAdminAdmin()" href="/auditoria" class="nav-item" :class="{ active: isActive(['/auditoria']) }">
          <i class="bi bi-shield-check nav-icon"></i>
          <span>Auditoría</span>
        </a>

      </nav>

      <!-- Footer del sidebar -->
      <div class="sidebar-footer">
        <div class="sidebar-user">
          <div class="sidebar-user-avatar">
            {{ (user.name || 'U').charAt(0).toUpperCase() }}
          </div>
          <div class="sidebar-user-info">
            <span class="sidebar-user-name">{{ user.name }} {{ user.apellido }}</span>
            <span class="sidebar-user-role">{{ user.cargo }}</span>
          </div>
        </div>
        <button class="sidebar-logout-btn" @click="logout" title="Cerrar sesión">
          <i class="bi bi-box-arrow-right"></i>
        </button>
      </div>

    </aside>

    <!-- ── Main ── -->
    <div class="app-main">

      <!-- Topbar -->
      <header class="app-topbar">
        <button class="topbar-menu-btn" @click="toggleSidebarDesktop" title="Colapsar menú">
          <i class="bi bi-layout-sidebar"></i>
        </button>
        <button class="topbar-menu-btn-mobile" @click="toggleSidebar">
          <i class="bi bi-list"></i>
        </button>

        <div class="topbar-breadcrumb">
          <span class="topbar-page-title">{{ pageTitle }}</span>
        </div>

        <div class="topbar-right">
          <div class="topbar-user-pill" ref="menuUsuario" :class="{ abierto: menuUsuarioAbierto }"
            role="button" tabindex="0" aria-haspopup="menu" :aria-expanded="menuUsuarioAbierto ? 'true' : 'false'"
            @click="menuUsuarioAbierto = !menuUsuarioAbierto" @keydown.enter.prevent="menuUsuarioAbierto = !menuUsuarioAbierto">
            <div class="topbar-avatar">{{ (user.name || 'U').charAt(0).toUpperCase() }}</div>
            <div class="topbar-user-text">
              <span class="topbar-user-name">{{ user.name }} {{ user.apellido }}</span>
              <span class="topbar-user-role">{{ user.cargo }}</span>
            </div>
            <div class="topbar-user-menu" role="menu" @click.stop>
              <button class="topbar-user-menu-btn" role="menuitem" @click="logout">
                <i class="bi bi-box-arrow-right me-2"></i>Cerrar sesión
              </button>
            </div>
          </div>
        </div>
      </header>

      <!-- Content -->
      <main class="app-content">
        <div class="view-container">
          <router-view></router-view>
        </div>
      </main>

    </div>

  </div>
</template>

<script>
import { mapActions } from 'vuex'
import axios from 'axios'

export default {
  name: 'LayoutComponent',
  data() {
    return {
      user: {},
      menuOpen: {
        'local-mercaderia': false,
        'local-documentos': false,
        'provincia-mercaderia': false,
        'provincia-documentos': false,
        'gestion-costos': false,
        'gestion-flota': false,
      },
      sidebarVisible: false,
      sidebarCollapsed: false,
      menuUsuarioAbierto: false,
    }
  },
  computed: {
    currentRoute() { return this.$route.path },
    pageTitle() {
      const titles = {
        '/dashboard': 'Dashboard',
        '/programacion': 'Programación Local',
        '/programacion-documentos': 'Programación Documentos',
        '/listado-envios-locales': 'Listado Envíos Locales',
        '/listado-envios-documentos-locales': 'Listado Envíos Documentos',
        '/documentos-transporte': 'Documentos de Transporte',
        '/listado-envios/mercaderia': 'Listado Mercadería',
        '/listado-envios/documentos': 'Listado Documentos',
        '/datos-agente': 'Datos de Agente',
        '/cotizador': 'Calculadora',
        '/tracking': 'Rastreo Provincia',
        '/tracking-local': 'Rastreo Local',
        '/company': 'Gestión de Clientes',
        '/gestion-costo-aereo': 'Costos Aéreos',
        '/gestion-costo-terrestre': 'Costos Terrestres',
        '/gestion-costo-terrestre-exclusivo': 'Costos Exclusivos',
        '/gestion-tipos-unidades': 'Tipos de Unidades',
        '/gestion-vehiculos': 'Vehículos',
        '/gestion-metodo-envio': 'Métodos de Envío',
        '/datos-personal': 'Gestión de Personal',
        '/gestion-usuarios': 'Gestión de Usuarios',
        '/auditoria': 'Auditoría',
      }
      return titles[this.$route.path] || 'ANW Logistics'
    }
  },
  methods: {
    ...mapActions({ logoutAction: 'logout' }),
    // Menú del usuario: se abre con clic (y con hover), se cierra al hacer clic fuera o con Esc
    cerrarMenuUsuario(e) {
      if (e.type === 'keydown' && e.key !== 'Escape') return
      if (e.type === 'click' && this.$refs.menuUsuario && this.$refs.menuUsuario.contains(e.target)) return
      this.menuUsuarioAbierto = false
    },
    async logout() {
      try {
        await axios.post('/logout', {})
      } catch (_) { /* silent */ }
      this.logoutAction()
      this.$router.push('/login')
    },
    esAdmin() {
      const c = this.user?.cargo?.toLowerCase()
      return c === 'admin' || c === 'admin-draeger'
    },
    esExterno() {
      return this.user?.tipo_usuario?.toLowerCase() === 'externo'
    },
    esSuperAdminAdmin() {
      return this.user?.cargo?.toLowerCase() === 'admin'
    },
    isActive(paths) {
      if (!Array.isArray(paths)) return false
      return paths.some(p => this.$route.path === p)
    },
    isParentActive(childPaths) {
      if (!Array.isArray(childPaths)) return false
      return childPaths.some(path => {
        if (path.endsWith('/*')) {
          return this.$route.path.startsWith(path.slice(0, -1))
        }
        if (path.includes(':')) {
          const prefix = path.split('/:')[0] + '/'
          return this.$route.path.startsWith(prefix) && this.$route.path.length > prefix.length
        }
        if (this.$route.path === path) return true
        if (path !== '/' && this.$route.path.startsWith(path)) {
          const next = this.$route.path.charAt(path.length)
          return next === '/' || next === '' || next === '?'
        }
        return false
      })
    },
    toggleMenu(key) {
      this.menuOpen[key] = !this.menuOpen[key]
    },
    toggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible
    },
    toggleSidebarDesktop() {
      this.sidebarCollapsed = !this.sidebarCollapsed
    },
    syncMenuOpenWithRoute() {
      this.menuOpen['local-mercaderia'] = this.isParentActive(['/programacion', '/envios-locales-emergencias', '/listado-envios-locales'])
      this.menuOpen['local-documentos'] = this.isActive(['/programacion-documentos', '/envios-locales-documentos-emergencias', '/listado-envios-documentos-locales'])
      this.menuOpen['provincia-mercaderia'] = this.isParentActive(['/envios/*', '/listado-envios/mercaderia'])
      this.menuOpen['provincia-documentos'] = this.isParentActive(['/envios-documentos/*', '/listado-envios/documentos'])
      this.menuOpen['gestion-costos'] = this.isActive(['/gestion-costo-aereo', '/gestion-costo-terrestre', '/gestion-costo-terrestre-exclusivo'])
      this.menuOpen['gestion-flota'] = this.isActive(['/gestion-tipos-unidades', '/gestion-vehiculos'])
    },
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem('user') || '{}')
    this.syncMenuOpenWithRoute()
    document.addEventListener('click', this.cerrarMenuUsuario)
    document.addEventListener('keydown', this.cerrarMenuUsuario)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.cerrarMenuUsuario)
    document.removeEventListener('keydown', this.cerrarMenuUsuario)
  },
  watch: {
    '$route.path'() {
      this.menuUsuarioAbierto = false
      this.syncMenuOpenWithRoute()
      if (this.sidebarVisible) this.sidebarVisible = false
    }
  }
}
</script>

<style scoped>
/* ────────────────────────────────────────────
   Shell
──────────────────────────────────────────── */
.app-shell {
  display: flex;
  min-height: 100vh;
  background: #f4f5fb;
}

/* ────────────────────────────────────────────
   Sidebar
──────────────────────────────────────────── */
.app-sidebar {
  width: 256px;
  flex-shrink: 0;
  background: linear-gradient(180deg, #1a237e 0%, #283593 100%);
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: sticky;
  top: 0;
  overflow: hidden;
  z-index: 10;
  transition: width 0.3s ease, transform 0.3s ease;
}
.app-sidebar.collapsed {
  width: 0;
}

/* Brand */
.sidebar-brand {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px;
  border-bottom: 1px solid rgba(255,255,255,0.1);
  flex-shrink: 0;
}
.sidebar-brand-link {
  display: flex;
  align-items: baseline;
  gap: 6px;
  text-decoration: none;
}
.sidebar-brand-name {
  font-size: 1.55rem;
  font-weight: 900;
  color: #fff;
  letter-spacing: 5px;
  text-transform: uppercase;
  line-height: 1;
}
.sidebar-brand-tag {
  font-size: 0.58rem;
  font-weight: 600;
  letter-spacing: 3.5px;
  text-transform: uppercase;
  color: rgba(255,255,255,0.45);
  align-self: flex-end;
  margin-bottom: 2px;
}
.sidebar-close-btn {
  background: rgba(255,255,255,0.1);
  border: none;
  color: #fff;
  border-radius: 6px;
  width: 30px; height: 30px;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer;
  font-size: 0.9rem;
}
.sidebar-close-btn:hover { background: rgba(255,255,255,0.2); }

/* Nav scroll area */
.sidebar-nav {
  flex: 1;
  overflow-y: auto;
  padding: 12px 10px;
  scrollbar-width: thin;
  scrollbar-color: rgba(255,255,255,0.15) transparent;
}
.sidebar-nav::-webkit-scrollbar { width: 4px; }
.sidebar-nav::-webkit-scrollbar-thumb { background: rgba(255,255,255,0.15); border-radius: 4px; }

/* Section labels */
.nav-section-label {
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: rgba(255,255,255,0.4);
  padding: 16px 10px 6px;
}

/* Nav item (link directo) */
.nav-item {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 9px 12px;
  border-radius: 9px;
  color: rgba(255,255,255,0.75);
  font-size: 0.855rem;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  margin-bottom: 2px;
}
.nav-item:hover {
  background: rgba(255,255,255,0.1);
  color: #fff;
}
.nav-item.active {
  background: #fff;
  color: #1a237e;
  font-weight: 700;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}
.nav-item.active .nav-icon { color: #3f51b5; }

/* Nav icons */
.nav-icon {
  font-size: 1rem;
  width: 18px;
  text-align: center;
  flex-shrink: 0;
  color: rgba(255,255,255,0.55);
  transition: color 0.15s;
}
.nav-item:hover .nav-icon { color: rgba(255,255,255,0.9); }

/* Group (collapsible) */
.nav-group { margin-bottom: 2px; }
.nav-group-toggle {
  display: flex;
  align-items: center;
  gap: 11px;
  width: 100%;
  padding: 9px 12px;
  border-radius: 9px;
  background: none;
  border: none;
  color: rgba(255,255,255,0.75);
  font-size: 0.855rem;
  font-weight: 500;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s, color 0.15s;
}
.nav-group-toggle:hover {
  background: rgba(255,255,255,0.1);
  color: #fff;
}
.nav-group.open .nav-group-toggle {
  background: rgba(255,255,255,0.08);
  color: #fff;
}
.nav-group-toggle span { flex: 1; }
.nav-chevron {
  font-size: 0.65rem;
  transition: transform 0.25s;
  color: rgba(255,255,255,0.4);
}
.nav-group.open .nav-chevron { transform: rotate(90deg); }

/* Submenu */
.nav-sub {
  display: none;
  padding: 4px 0 4px 40px;
}
.nav-group.open .nav-sub { display: block; }
.nav-sub-item {
  display: block;
  padding: 7px 12px;
  border-radius: 7px;
  color: rgba(255,255,255,0.6);
  font-size: 0.82rem;
  font-weight: 500;
  text-decoration: none;
  transition: background 0.15s, color 0.15s;
  margin-bottom: 1px;
  position: relative;
}
.nav-sub-item::before {
  content: '';
  position: absolute;
  left: -2px;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: rgba(255,255,255,0.3);
  transition: background 0.15s;
}
.nav-sub-item:hover {
  background: rgba(255,255,255,0.08);
  color: #fff;
}
.nav-sub-item:hover::before { background: #fff; }
.nav-sub-item.active {
  background: rgba(255,255,255,0.15);
  color: #fff;
  font-weight: 700;
}
.nav-sub-item.active::before { background: #90caf9; }

/* Sidebar footer */
.sidebar-footer {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  border-top: 1px solid rgba(255,255,255,0.1);
  flex-shrink: 0;
  background: rgba(0,0,0,0.15);
}
.sidebar-user { display: flex; align-items: center; gap: 10px; flex: 1; min-width: 0; }
.sidebar-user-avatar {
  width: 34px; height: 34px;
  border-radius: 50%;
  background: rgba(255,255,255,0.2);
  color: #fff;
  font-size: 0.9rem;
  font-weight: 800;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.sidebar-user-info { display: flex; flex-direction: column; min-width: 0; }
.sidebar-user-name {
  color: #fff;
  font-size: 0.78rem;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sidebar-user-role {
  color: rgba(255,255,255,0.5);
  font-size: 0.7rem;
  text-transform: capitalize;
}
.sidebar-logout-btn {
  background: rgba(255,255,255,0.1);
  border: none;
  color: rgba(255,255,255,0.7);
  border-radius: 7px;
  width: 32px; height: 32px;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer;
  font-size: 1rem;
  flex-shrink: 0;
  transition: background 0.15s, color 0.15s;
}
.sidebar-logout-btn:hover { background: rgba(220,53,69,0.3); color: #ff8a80; }

/* ────────────────────────────────────────────
   Main
──────────────────────────────────────────── */
.app-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: #f4f5fb;
}

/* Topbar */
.app-topbar {
  height: 60px;
  flex-shrink: 0;
  background: #fff;
  border-bottom: 1px solid #e8eaf6;
  display: flex;
  align-items: center;
  padding: 0 24px;
  gap: 16px;
  z-index: 100;
  box-shadow: 0 1px 4px rgba(63,81,181,0.06);
  position: sticky;
  top: 0;
}
.topbar-menu-btn {
  background: none;
  border: none;
  font-size: 1.3rem;
  color: #3f51b5;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.topbar-menu-btn:hover { background: #f0f1fa; }
.topbar-menu-btn-mobile {
  display: none;
  background: none;
  border: none;
  font-size: 1.4rem;
  color: #3f51b5;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
}
.topbar-menu-btn-mobile:hover { background: #f0f1fa; }
.topbar-breadcrumb { flex: 1; }
.topbar-page-title {
  font-size: 1rem;
  font-weight: 700;
  color: #1a237e;
}
.topbar-right { display: flex; align-items: center; gap: 12px; }

/* User pill en topbar */
.topbar-user-pill {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 12px 6px 6px;
  border-radius: 40px;
  background: #f4f5fb;
  border: 1px solid #e8eaf6;
  position: relative;
  cursor: pointer;
}
.topbar-user-pill:focus-visible { outline: 2px solid #3f51b5; outline-offset: 2px; }
.topbar-avatar {
  width: 30px; height: 30px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3f51b5, #283593);
  color: #fff;
  font-size: 0.8rem;
  font-weight: 800;
  display: flex; align-items: center; justify-content: center;
}
.topbar-user-text { display: flex; flex-direction: column; }
.topbar-user-name { font-size: 0.8rem; font-weight: 700; color: #1a237e; line-height: 1.2; }
.topbar-user-role { font-size: 0.68rem; color: #90a4ae; text-transform: capitalize; }
.topbar-user-menu {
  display: none;
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.12);
  border: 1px solid #e8eaf6;
  padding: 6px;
  min-width: 180px;
  z-index: 200;
}
/* Puente invisible sobre el hueco de 8px: el hover no se pierde al bajar el mouse hacia el menú */
.topbar-user-menu::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: -10px;
  height: 10px;
}
.topbar-user-pill:hover .topbar-user-menu,
.topbar-user-pill.abierto .topbar-user-menu { display: block; }
.topbar-user-menu-btn {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 9px 12px;
  border: none;
  background: none;
  font-size: 0.85rem;
  color: #c62828;
  font-weight: 600;
  border-radius: 7px;
  cursor: pointer;
}
.topbar-user-menu-btn:hover { background: #ffebee; }

/* Content */
.app-content {
  flex: 1;
  min-width: 0;
  background: #f4f5fb;
  padding: 0;
  -webkit-overflow-scrolling: touch;
}
.view-container {
  max-width: 100%;
  padding: 24px 28px;
}


@media (max-width: 768px) {
  .view-container { padding: 16px; }
}

/* Overlay mobile */
.sidebar-overlay {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  z-index: 499;
}
.sidebar-overlay.active { display: block; }

/* ────────────────────────────────────────────
   Responsive
──────────────────────────────────────────── */
@media (max-width: 1100px) {
  .app-sidebar {
    position: fixed;
    left: 0; top: 0;
    height: 100vh !important;
    width: 256px !important;
    transform: translateX(-100%);
    z-index: 500;
  }
  .app-sidebar.open { transform: translateX(0); }
  .topbar-menu-btn { display: none; }
  .topbar-menu-btn-mobile { display: flex; }
}

@media (max-width: 576px) {
  .topbar-user-text { display: none; }
  .app-topbar { padding: 0 14px; }
}
</style>
